import { cn } from '@dialogueconsulting/sked-ui/lib/utils'

import { Skeleton } from 'ui/skeleton'
import type { PreviewVariant } from 'utils/postPreviewVariant'

interface LoadingPlaceholderProps {
  isMobile?: boolean
  previewVariant?: PreviewVariant
}

const LEGACY_DESKTOP_GRID_CLASS = 'grid-cols-[1fr_440px_1fr]'

const UPLIFT_DESKTOP_GRID_CLASS =
  'grid-cols-[minmax(480px,1fr)_minmax(480px,auto)_minmax(480px,1fr)] max-[1280px]:grid-cols-[minmax(300px,1fr)_minmax(440px,auto)_minmax(300px,1fr)]'

export const getLoadingPlaceholderGridClassName = ({
  isMobile,
  previewVariant = 'legacy',
}: LoadingPlaceholderProps) => {
  if (isMobile) {
    return 'mt-0 h-[85vh] grid-cols-1'
  }

  return previewVariant === 'uplift'
    ? UPLIFT_DESKTOP_GRID_CLASS
    : LEGACY_DESKTOP_GRID_CLASS
}

// SKE-3790: rebuilt on the kit Skeleton primitive — each bar carries the
// design-system shimmer, replacing the old static `#eeeeee` bars + rotated
// white "LightOpaque" sweep overlays.
const Bar = ({
  width,
  height,
  className,
}: {
  width: string
  height: string
  className?: string
}) => (
  <Skeleton
    className={cn('mb-[10px] rounded-[5px]', className)}
    style={{ width, height }}
  />
)

const Column = ({ children }: { children: React.ReactNode }) => (
  <div className="relative border-r border-[#e5e5e5] p-[38px] last:border-r-0">
    {children}
  </div>
)

const LoadingPlaceholder: React.FC<LoadingPlaceholderProps> = ({
  isMobile,
  previewVariant = 'legacy',
}) => {
  return (
    <div
      data-testid="loading-placeholder-container"
      className={cn(
        'mt-[3px] grid h-screen overflow-hidden',
        getLoadingPlaceholderGridClassName({ isMobile, previewVariant })
      )}
    >
      {!isMobile && (
        <Column>
          <Bar width="50%" height="35px" />
          <Bar width="70%" height="35px" />
          <Bar width="95%" height="118px" />
        </Column>
      )}
      <Column>
        <Bar width="60%" height="35px" />
        <div className="grid place-items-center">
          <Bar width="90%" height="35px" className="mb-[22px]" />
          <Bar width="90%" height="350px" className="mb-[22px]" />
          <Bar width="90%" height="35px" />
        </div>
      </Column>
      {!isMobile && (
        <Column>
          <Bar width="60%" height="35px" className="mb-[30px]" />
          <Bar width="90%" height="60px" className="ml-[10px]" />
          <Bar width="60%" height="35px" className="mb-[36px]" />
          <Bar width="90%" height="250px" className="ml-[10px]" />
        </Column>
      )}
    </div>
  )
}

export default LoadingPlaceholder
